import { GetPurchaseItemLimitNum } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { verify } from '@/epp/expertmain/common/js/verify'
import { CheckIdCard } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment/moment'

/**
 * 获取文件base64
 * @param file
 * @returns {Promise<unknown>}
 */
export const GetBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

/**
 * 获取限制品目数量
 * @returns {Promise<number>}
 */
export const getItemLimitNum = async () => {
  let limitNum = 0
  try {
    let res = await GetPurchaseItemLimitNum()
    if (200 === res.code) {
      limitNum = res.result && Number(res.result)
    }
  } catch (e) {
    this.$message.error(e.message)
  } finally {
  }
  return limitNum
}

/**
 * 校验评审品目数量
 * @param rule
 * @param value
 * @param callback
 * @returns {Promise<void>}
 */
export const checkPurchaseItemNum = async (rule, value, callback) => {
  let expert_item_max_num = await getItemLimitNum()
  if (value && value.split(',').length > expert_item_max_num) {
    callback(new Error(`评审品目有误！最多选择${expert_item_max_num}个评审品目`))
  }
  callback()
}

/**
 * 计算日期相隔多少年
 * @param date moment()
 * @returns {string}
 */
export const CalculateAge = (date) => {
  if (!date) {
    return
  }
  //计算日期相差多少月
  let month = moment().diff(date, 'months')
  //保留一位小数
  return (month / 12).toFixed(1)
}

